import { render } from "./table-type.svg?vue&type=template&id=c6639aec?inline"
const script = {}
script.render = render

export default script